import React, { useState, useEffect } from "react";
import AdminAppBody from "../../../../components/admin/AdminAppBody";
import PageHeading from "../../../../components/admin/common/PageHeading";
import { FaEye, FaEdit, FaTrash, FaSearch } from "react-icons/fa";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import useApiCallHooks from "../../../../hooks/useApiCallHooks";
import { apiRoutes } from "../../../../routes/api/apiRoutes";
import { uiRoutes } from "../../../../routes/ui/uiRoutes";
const ProgramList = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [typeFilter, setTypeFilter] = useState("");
  const [list, setList] = useState([]);
  const [isDelete, setIsDelete] = useState(false);
  const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();
  // Initial Fetch
  useEffect(() => {
    callAPI("get", "admin/programs", "");
  }, []);
  // Handle delete
  const deleteRecord = (id) => {
    callAPI("delete", `${"admin/programs"}/${id}`, "");
  };
  // Refresh on delete success
  useEffect(() => {
    if (statusCode === 204 && !isDelete) {
      toast.success("Program deleted successfully!");
      callAPI("get", "admin/programs", "");
      setIsDelete(true);
    }
  }, [statusCode, isDelete]);
  // Handle API response
  useEffect(() => {
    if (responce?.data && statusCode === 200) {
      setList(responce.data);
      setIsDelete(false);
    }
  }, [responce, statusCode]);
  const filteredPrograms = list.filter(
    (program) =>
      (program.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        program.tag.toLowerCase().includes(searchTerm.toLowerCase())) &&
      (typeFilter ? program.type === typeFilter : true)
  );
  return (
    <AdminAppBody
      loading={loading}
      content={
        <div className="container">
          <div className="row align-items-center mb-3">
            <div className="col-md-6">
              <PageHeading
                title="Program List"
                subTitle="Manage all training programs and details."
              />
            </div>
            <div className="col-md-6 text-end">
              <Link to={uiRoutes.admin.program.add}>
                <button className="btn btn-primary">Add Program</button>
              </Link>
            </div>
          </div>
          <div className="sys-list-table card shadow-sm rounded-lg mt-4 overflow-hidden">
            <div className="px-4 py-3 border-bottom bg-white">
              <div className="row align-items-center">
                <div className="col-md-3">
                  <h5 className="mb-0 fw-semibold">Programs</h5>
                </div>
                <div className="col-md-5">
                  <div className="input-group">
                    <span className="input-group-text bg-white border-end-0">
                      <FaSearch />
                    </span>
                    <input
                      type="text"
                      className="form-control border-start-0"
                      placeholder="Search by name or tag"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <select
                    className="form-select"
                    value={typeFilter}
                    onChange={(e) => setTypeFilter(e.target.value)}
                  >
                    <option value="">Filter by type</option>
                    <option value="student">Student</option>
                    <option value="kids">Kids</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-hover align-middle sys-list-table__content">
                <thead className="bg-light text-dark text-uppercase small">
                  <tr>
                    <th className="px-4 py-2">Sr No.</th>
                    <th className="px-4 py-2">Program</th>
                    <th className="px-4 py-2">Duration</th>
                    <th className="px-4 py-2">Type</th>
                    <th className="px-4 py-2">Age Group</th>
                    <th className="px-4 py-2">Rating</th>
                    <th className="px-4 py-2">Tag</th>
                    <th className="px-4 py-2">Price (₹)</th>
                    <th className="px-4 py-2 text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredPrograms.length === 0 ? (
                    <tr>
                      <td colSpan="9" className="text-center py-4">
                        No programs found.
                      </td>
                    </tr>
                  ) : (
                    filteredPrograms.map((program, index) => (
                      <tr
                        key={program.id}
                        className="sys-list-table__row border-bottom"
                      >
                        <th className="px-4 py-2">{index + 1}</th>
                        <td className="px-4 py-2 d-flex align-items-center">
                          <img
                            src={
                              program.image ||
                              "https://via.placeholder.com/40"
                            }
                            alt={program.name}
                            className="rounded me-3"
                            style={{
                              width: "40px",
                              height: "40px",
                              objectFit: "cover",
                            }}
                          />
                          <span className="fw-medium">{program.name}</span>
                        </td>
                        <td className="px-4 py-2">{program.duration}</td>
                        <td className="px-4 py-2 text-capitalize">
                          {program.type}
                        </td>
                        <td className="px-4 py-2">{program.age}</td>
                        <td className="px-4 py-2">{program.rating}</td>
                        <td className="px-4 py-2">{program.tag}</td>
                        <td className="px-4 py-2">{program.price}</td>
                        <td className="px-4 py-2 text-center">
                          <div className="d-flex justify-content-center gap-2">
                            <Link
                              to={uiRoutes.admin.program.edit.replace(
                                ":id",
                                program.id
                              )}
                            >
                              <button
                                className="sys-list-table__action edit"
                                title="Edit Program"
                              >
                                <FaEdit />
                              </button>
                            </Link>
                            <button
                              className="sys-list-table__action delete"
                              title="Delete Program"
                              onClick={() => deleteRecord(program.id)}
                            >
                              <FaTrash />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      }
    />
  );
};
export default ProgramList;